import * as z from "zod/v4";

export const getEbayAuthorizationUrl = {
  name: "getEbayAuthorizationUrl" as const,
  // No input parameters needed - will use current team context
  input: z.object({}),

  // Output is the URL string for eBay authorization
  output: z.string(),
};
